const templateUrl = require('./help.html');

const app = angular.module('msi.shipments.sent.help', []);

app.component('ogSentShipmentHelp', {
  templateUrl: templateUrl
});

module.exports = app.name;
